import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { CheckingAccountResponseDto, ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetCurrentAccountClientCommand extends IRequestCommand<
  IGetCurrentAccountClientResponse,
  ErrorDetails,
  IGetCurrentAccountClientCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierUserId}/passenger/{passengerUserId}/hasCheckingAccount';
  public override setParameters(parameters: IGetCurrentAccountClientCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{passengerUserId}',
      parameters.passengerUserId.toString()
    );
  }
}

export interface IGetCurrentAccountClientCommandParameters
  extends ICommandParameters {
  passengerUserId: string;
  carrierUserId: string;
}

export interface IGetCurrentAccountClientResponse
  extends ICommandResponse,
    CheckingAccountResponseDto {}
